import { patchState, signalStoreFeature, withMethods, withState } from '@ngrx/signals';

import { EMPTY_DESCRIPTION, ProblemDescription } from '@core/models/problem-description.model';

export interface DescriptionState {
  description: ProblemDescription;
}

export const INITIAL_DESCRIPTION_STATE: DescriptionState = {
  description: EMPTY_DESCRIPTION,
};

export function withDescription() {
  return signalStoreFeature(
    withState<DescriptionState>(INITIAL_DESCRIPTION_STATE),
    withMethods((store) => ({
      saveDescription: (description: ProblemDescription): void =>
        patchState(store, { description }),

      setTheme: (theme: string): void =>
        patchState(store, (state) => ({ description: { ...state.description, theme } })),

      setDescription: (text: string): void =>
        patchState(store, (state) => ({
          description: { ...state.description, description: text },
        })),

      addAttachment: (file: File): void =>
        patchState(store, (state) => ({
          description: {
            ...state.description,
            attachments: [...state.description.attachments, file],
          },
        })),

      removeAttachment: (file: File): void =>
        patchState(store, (state) => ({
          description: {
            ...state.description,
            attachments: state.description.attachments.filter((f) => f !== file),
          },
        })),
    })),
  );
}
